import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { LandingPageProvider } from './contexts/LandingPageContext';
import { AuthProvider } from './contexts/AuthContext';
import Cursor from './Cursor';
import HomePage from './components/HomePage/HomePage';
import i18n from './i18n';
import Impressum from './components/Impressum';
import GalleryPage from './components/GalleryPage/GalleryPage';
import EventsPage from './components/EventsPage/EventsPage';
import ContactPage from './components/ContactPage/ContactPage';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const ADMIN_PATHS = ['/dashboard', '/login'];

const ConditionalCursor = () => {
  const location = useLocation();
  const onAdmin = ADMIN_PATHS.some((path) => location.pathname.startsWith(path));

  useEffect(() => {
    const body = document.body;
    body.classList.toggle('default-cursor', onAdmin);
    body.classList.toggle('landing-cursor', !onAdmin);
    return () => {
      body.classList.remove('default-cursor');
      body.classList.remove('landing-cursor');
    };
  }, [onAdmin]);

  return onAdmin ? null : <Cursor />;
};

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <LandingPageProvider>
          <Router>
            <ConditionalCursor />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard/*"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </LandingPageProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
